import{jsx as e,Fragment as r}from"react/jsx-runtime";import{Fragment as t}from"react";function n(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function o(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{},o=Object.keys(t);"function"==typeof Object.getOwnPropertySymbols&&(o=o.concat(Object.getOwnPropertySymbols(t).filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})))),o.forEach((function(r){n(e,r,t[r])}))}return e}function c(e,r){return r=null!=r?r:{},Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):function(e){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var t=Object.getOwnPropertySymbols(e);r.push.apply(r,t)}return r}(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))})),e}
/**
 * 라디오 버튼 그룹을 구성하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {RadioItemProps[]} props.data - 라디오 버튼 아이템들의 데이터 배열 ({label, value, description, onChange, className, RadioClassName}[])
 * @param {string} props.name - 라디오 그룹의 name 속성
 * @param {string} props.selectedValue - 현재 선택된 라디오 버튼의 값
 * @param {Function} props.onChange - 라디오 버튼 선택 변경 시 호출되는 핸들러 함수
 * @param {Function} props.children - 각 라디오 버튼 아이템을 렌더링하는 렌더 프롭 함수
 * @param {boolean} [props.isError] - 에러 상태 여부
 * @param {boolean} [props.isDisabled] - 비활성화 상태 여부
 *
 * @example
 * ```tsx
 * const radioItems = [
 *   { label: '옵션 1', value: '1', description: '첫 번째 옵션입니다.' },
 *   { label: '옵션 2', value: '2', description: '두 번째 옵션입니다.' }
 * ];
 *
 * <RadioGroup
 *   data={radioItems}
 *   name="options"
 *   selectedValue="1"
 *   onChange={(e) => console.log(e.target.value)}
 * >
 *   {(item) => (
 *     <RadioButton
 *       label={item.label}
 *       value={item.value}
 *       description={item.description}
 *       isSelected={item.isSelected}
 *       onChange={item.onChange}
 *     />
 *   )}
 * </RadioGroup>
 * ```
 */const i=({data:n,selectedValue:i,children:a,onChange:l,isError:s,isDisabled:u})=>/*#__PURE__*/e(r,{children:n.map((r=>{const n=i===r.value;/*#__PURE__*/
return e(t,{children:a(c(o({},r),{onChange:l,isError:s,isDisabled:u,isSelected:n}))},r.value)}))});export{i as RadioGroup};
